<template>
  <div class="mb-5">
    <div class="container-xxl">
      <div class="row mb-xl">
        <GlobalSearchBar class="col-12"/>
      </div>
      <BrowseMenu/>
    </div>
  </div>
</template>

<script setup>
import GlobalSearchBar from './GlobalSearchBar'
import BrowseMenu from '@/components/global/browse/BrowseMenu.vue'
</script>
